<script>
    import GithubTableCell from "./GithubTableCell/GithubTableCell.svelte";

    export let dark;
    export let commits;
    export let timeScale

    const weekDays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

</script>

<div class="github-table">
    <div class="github-table-days" class:dark>
        {#each weekDays as day}
            <p>{day}</p>
        {/each}
    </div>
    <div class="github-scrollable-data">
        <div class="github-table-row">
            {#each commits as commit, i}
                <div class="github-table-column">
                    {#each commit as contributions, j}
                        <GithubTableCell
                                {dark}
                                commits={contributions.count}
                                date={contributions.date}
                                color={contributions.color}
                        />
                    {/each}
                </div>
            {/each}
        </div>
        <div class="github-time-scale-section">
            <div class="github-time-scale-line" class:dark></div>
            <div class="github-time-scale-container" class:dark>
                {#each timeScale as month}
                    <div class="github-time-scale">
                        <div class={`github-time-scale-cell ${month?.length > 0 ? 'github-time-scale-long-month' : 'github-time-scale-short-month'}`} class:dark></div>
                        <p class:dark>{month}</p>
                    </div>
                {/each}
            </div>
        </div>
    </div>
</div>

<style lang="scss">
    @import '../githubSection';
</style>